import Bell from 'lucide-react/dist/esm/icons/bell.mjs'; import Hash from 'lucide-react/dist/esm/icons/hash.mjs'; import Palette from 'lucide-react/dist/esm/icons/palette.mjs'; import Users from 'lucide-react/dist/esm/icons/users.mjs';
import type { Conversation, PresenceStatus } from './types.js';

export const STATUS_LABEL: Record<PresenceStatus, string> = { offline: 'ออฟไลน์', available: 'ว่าง', busy: 'ไม่ว่าง', meeting: 'ประชุม', away: 'ไม่อยู่' };
import { avatarTone, initials } from './format.js';

export function Avatar({ id, name, size = 40, online, status }: { id: string; name: string; size?: number; online?: boolean; status?: PresenceStatus }) {
  const st: PresenceStatus | undefined = status ?? (online === undefined ? undefined : online ? 'available' : 'offline');
  return (
    <span className={`xc-av xc-av-t${avatarTone(id)}`} style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }} aria-hidden="true">
      {initials(name)}
      {st && <span className={`xc-av-dot is-${st}`} />}
    </span>
  );
}

/** The conversation's picture: the other person for a DM, an icon for groups, channels, designs, system. */
export function ConvAvatar({ c, me, size = 44 }: { c: Conversation; me: string | null; size?: number }) {
  if (c.kind === 'dm') {
    const other = c.members.find((m) => m.userId !== me) ?? c.members[0];
    return <Avatar id={other?.userId ?? c.id} name={other?.name ?? c.title} size={size} status={other?.status ?? (other?.online ? 'available' : 'offline')} />;
  }
  const Icon = c.kind === 'channel' ? Hash : c.kind === 'design' ? Palette : c.kind === 'system' ? Bell : Users;
  return (
    <span className={`xc-av xc-av-icon xc-av-t${avatarTone(c.id)}`} style={{ width: size, height: size }} aria-hidden="true">
      <Icon size={Math.round(size * 0.46)} />
    </span>
  );
}
